import { createContext } from "react";
import { useAzureFileUploader } from "modules";
import { useImmer } from "use-immer";

export const TaskFileUploadContext = createContext();

export const TaskFileUploadScope = ({ children }) => {
  const [fileUploadState, setFileUploadState] = useImmer({
    extensions: [],
    studentTaskId: null,
    courseTaskId: null,
    taskGroup: null,
  });

  const { studentTaskId, courseTaskId, extensions, taskGroup } =
    fileUploadState;

  const mimeMap = {
    0: {
      mime: "application/pdf",
      extensions: [".pdf"],
    },
    1: {
      mime: "application/msword",
      extensions: [".doc", ".docx"],
    },
    2: {
      mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      extensions: [".xlsx"],
    },
  };

  const getSupportedExtensions = (support, mimeMap) => {
    return support?.flatMap((key) => mimeMap[key]?.extensions || []);
  };

  const supportedExtensions = getSupportedExtensions(extensions, mimeMap);

  const azureFileUploader = useAzureFileUploader({
    studentTaskId,
    supportedExtensions,
    courseTaskId,
    taskGroup,
  });

  return (
    <TaskFileUploadContext.Provider
      value={{
        ...azureFileUploader,
        supportedExtensions,
        setFileUploadState,
      }}
    >
      {children}
    </TaskFileUploadContext.Provider>
  );
};
